import { PaywallConfig } from 'src/app/admin/types.interface';
import { BillableFeature } from '@pncl/common-models';
import { Institution } from 'src/app/models/user';

export function validatePaywallConfigurationForInstitution(
  institution: Institution,
): string | undefined {
  const paywallConfig = institution.paywallConfig;
  if (!paywallConfig) {
    return `Paywall Error: Paywall configuration not set for institution with id : ${institution._id}.`;
  }
  if (!HasBillingConfigurationEntryAndPricePoint(paywallConfig, BillableFeature.SpaceDuration)) {
    return 'Paywall Error: Billing configuration entry for Space Duration is missing or its price point is not set.';
  }
  return;
}
function HasBillingConfigurationEntryAndPricePoint(
  paywallConfig: PaywallConfig,
  feature: BillableFeature,
): boolean {
  return (
    paywallConfig.billingConfiguration?.some(
      (config) => config.featureType === feature && config.pricePoint,
    ) ?? false
  );
}

/** Shared columns for both V1 and V2 billable-session CSV exports. */
const billingSessionBaseFieldsMap = {
  startDate: 'Start Date',
  endDate: 'End Date',
  spaceId: 'Space ID',
  spaceTitle: 'Space Title',
  sessionId: 'Session ID',
  numberOfAttendees: 'Number of Attendees',
  totalCallDuration: 'Total Call Duration (Hours)',
  totalSpaceDuration: 'Total Space Duration (Hours)',
} as const;

export const billingSessionReportFieldsMapV1 = {
  ...billingSessionBaseFieldsMap,
  billableSpaceTime: 'Billable Space Time (Hours)',
} as const;

export const billingSessionReportFieldsMapV2 = {
  ...billingSessionBaseFieldsMap,
  tierName: 'Tier',
  billedAmount: 'Billed Amount ($)',
  billableGroupSessionTime: 'Billable Group Session Time (Hours)',
  billableAdditionalParticipantTime: 'Billable Additional Participant Time (Hours)',
} as const;

export type BillingSessionDetailsV1 = {
  [K in keyof typeof billingSessionReportFieldsMapV1]: string | number;
};

export type BillingSessionDetailsV2 = {
  [K in keyof typeof billingSessionReportFieldsMapV2]: string | number;
};

export type BillingSessionDetails = BillingSessionDetailsV1 | BillingSessionDetailsV2;

/** Pick CSV columns from the same enableV2Billing flag the BE uses for projection. */
export function getBillingSessionCsvFieldMap(enableV2Billing: boolean) {
  return enableV2Billing ? billingSessionReportFieldsMapV2 : billingSessionReportFieldsMapV1;
}
